import React from "react";

const WeatherAlerts = ({ alerts }) => {
  const getAlertColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case "extreme":
        return "#880E4F";
      case "severe":
        return "#F44336";
      case "moderate":
        return "#FF9800";
      case "minor":
        return "#FFC107";
      default:
        return "#2196F3";
    }
  };

  const getAlertIcon = (event) => {
    const eventLower = event?.toLowerCase() || "";
    if (eventLower.includes("temperature") || eventLower.includes("heat"))
      return "🌡️";
    if (eventLower.includes("wind")) return "💨";
    if (eventLower.includes("rain") || eventLower.includes("flood"))
      return "🌧️";
    if (eventLower.includes("snow") || eventLower.includes("winter"))
      return "❄️";
    if (eventLower.includes("storm")) return "⛈️";
    if (eventLower.includes("fog")) return "🌫️";
    return "⚠️";
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString();
  };

  if (!alerts || alerts.length === 0) {
    return (
      <div className="bg-white rounded-lg p-4">
        <div className="text-center text-gray-500 py-4">
          No active weather alerts
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="space-y-4">
        {alerts.map((alert, index) => (
          <div
            key={index}
            className="border-l-4 p-4 rounded-r-lg bg-gray-50"
            style={{ borderColor: getAlertColor(alert.severity) }}
          >
            <div className="flex items-start gap-3">
              <div className="text-2xl">{getAlertIcon(alert.event)}</div>
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-medium text-gray-900">{alert.event}</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      {alert.description}
                    </p>
                    <div className="text-xs text-gray-500 mt-2">
                      <div>Start: {formatTimestamp(alert.start)}</div>
                      <div>End: {formatTimestamp(alert.end)}</div>
                      {alert.sender_name && (
                        <div className="mt-1">Source: {alert.sender_name}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeatherAlerts;
